export default __webpack_public_path__ + "static/media/Ecosystm-Awards-Logo.80236fd7.svg";